document.addEventListener("DOMContentLoaded", () => {

    const toggle = document.querySelectorAll('.toggle');
    toggle.forEach(el => el.addEventListener('click', event => {
        let sectionContentID = el.getAttribute('data-section-content');
        let sectionContentElement = document.getElementById(sectionContentID);
        let sectionContentInnerElement = sectionContentElement.querySelector('.section-content-inner');

        if (el.parentElement.classList.contains("active")) {
            el.parentElement.classList.remove("active");
            sectionContentElement.style.height = '0';
        } else {
            let allSections = document.querySelectorAll(".accordion .section.active");
            for (let i = 0; i < allSections.length; i++) {
                allSections[i].classList.remove('active');
                let sectionContentToClose = allSections[i].querySelector('.section-content');
                sectionContentToClose.style.height = '0';
            }
            el.parentElement.classList.add("active");
            sectionContentElement.style.height = sectionContentInnerElement.offsetHeight + 'px';
        }
    }));

});
